var map = {
	"./black.png": 1022,
	"./blue.png": 1023,
	"./brown.png": 1024,
	"./gray.png": 1025,
	"./green.png": 1026,
	"./orange.png": 1027,
	"./pantone-logo.png": 712,
	"./pink.png": 1028,
	"./poc-spinner.png": 668,
	"./purple.png": 1029,
	"./red.png": 1030,
	"./white.png": 1031,
	"./yellow.png": 1032
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 713;